/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ClassActionsRepresentationFromJSON, ClassActionsRepresentationToJSON, FeaturesRepresentationFromJSON, FeaturesRepresentationToJSON, } from './';
export function CurrentUserRepresentationFromJSON(json) {
    return CurrentUserRepresentationFromJSONTyped(json, false);
}
export function CurrentUserRepresentationFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        keycloakId: json['keycloakId'],
        firstName: json['firstName'],
        lastName: json['lastName'],
        email: json['email'],
        avatar: json['avatar'],
        isSuperUser: json['isSuperUser'],
        features: FeaturesRepresentationFromJSON(json['features']),
        classActions: ClassActionsRepresentationFromJSON(json['classActions']),
        zendeskJwt: json['zendeskJwt'],
    };
}
export function CurrentUserRepresentationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        keycloakId: value.keycloakId,
        firstName: value.firstName,
        lastName: value.lastName,
        email: value.email,
        avatar: value.avatar,
        isSuperUser: value.isSuperUser,
        features: FeaturesRepresentationToJSON(value.features),
        classActions: ClassActionsRepresentationToJSON(value.classActions),
        zendeskJwt: value.zendeskJwt,
    };
}
